import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PaymentSuccessPage from './PaymentSuccessPage';
import PaymentFailurePage from './PaymentFailurePage';

function App() {
  return (
    <Router>
      <Routes>
        {/* Define your routes here */}
        <Route path="/pay/payment-success" element={<PaymentSuccessPage />} />
        <Route path="/pay/payment-failed" element={<PaymentFailurePage />} />
      </Routes>
    </Router>
  );
}

export default App;